module.exports = __webpack_public_path__ + "static/media/Hbook-19.a0b7e9bf.jpg";